export const SET_AUTH_OPENED = "TVTRANS/SET_AUTH_OPENED";

export const SET_AUTH_MODE = "TVTRANS/SET_AUTH_MODE";

export const SET_CHAT_OPENED = "TVTRANS/SET_CHAT_OPENED";